import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
//import './index.css';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);
serviceWorker.unregister();




// WEBPACK FOOTER //
// ./src/index.tsx